const breakPointMd = 768

export function getBreakPointIsUpToMedium() {
    return window.screen.width <= breakPointMd
}
